export const CONDITION_CREATE_RESET = 'CONDITION_CREATE_RESET'
export const CONDITION_CREATE_SET_CREATED = 'CONDITION_CREATE_SET_CREATED'
export const CONDITION_CREATE_SET_ERROR = 'CONDITION_CREATE_SET_ERROR'
export const CONDITION_CREATE_SET_VIOLATIONS = 'CONDITION_CREATE_SET_VIOLATIONS'
export const CONDITION_CREATE_TOGGLE_LOADING = 'CONDITION_CREATE_TOGGLE_LOADING'
